// hooks/useActivityTracker.ts
import { useCallback, useEffect } from "react";
import { useLocation } from "react-router-dom";

interface ActivityPayload {
  sessionId: string;
  activityType: string;
  activityDetails: string;
  activityDescription?: string;
}

const getOrCreateSessionId = (): string => {
  let sessionId = sessionStorage.getItem("sessionId");

  if (!sessionId) {
    sessionId = crypto.randomUUID();
    sessionStorage.setItem("sessionId", sessionId);
  }

  return sessionId;
};

export const useActivityTracker = (
  autoTrackPageView = false,
  overrideDetails?: string,
  overrideDescription?: string
) => {
  const location = useLocation();

  const trackActivity = useCallback(
    async (
      activityType: string,
      activityDetails: string,
      activityDescription?: string
    ) => {
      const payload: ActivityPayload = {
        sessionId: getOrCreateSessionId(),
        activityType,
        activityDetails,
        activityDescription,
      };

      try {
        await fetch(`${process.env.REACT_APP_API_BASE_URL}/activity/add`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        });
      } catch {
        // silent fail (can enhance later)
      }
    },
    []
  );

  useEffect(() => {
    if (!autoTrackPageView) return;

    const fullPath = location.pathname + location.search;

    trackActivity(
      "PageView",
      overrideDetails ?? fullPath,
      overrideDescription
    );
  }, [
    location.pathname,
    location.search,
    autoTrackPageView,
    overrideDetails,
    overrideDescription,
    trackActivity,
  ]);

  return { trackActivity };
};